import React from 'react';
import { ConfirmationModal } from '../../../../components/ConfirmationModal';
import { APIKeyStatus } from '../../../../entities/APIKey';

interface APIKeyEnableDisableModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  setIsOpen: (open: boolean) => void;
  apiKeyStatus: APIKeyStatus;
}

export const APIKeyEnableDisableModal: React.FC<
  APIKeyEnableDisableModalProps
> = ({ isOpen, onConfirm, setIsOpen, apiKeyStatus }) => {
  const isRevoked = apiKeyStatus === APIKeyStatus.Revoked;

  return (
    <ConfirmationModal
      title={isRevoked ? 'Re-enable API Key' : 'Revoke API Key'}
      body={
        isRevoked
          ? 'Are you sure you want to re-enable this API key?'
          : 'Are you sure you want to revoke this API key?'
      }
      isOpen={isOpen}
      onConfirm={onConfirm}
      onCancel={() => setIsOpen(false)}
      size='md'
      confirmText={isRevoked ? 'Re-enable' : 'Revoke'}
      disableAfterConfirm={true}
    />
  );
};
